// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3jpAw","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__2G1et","gfeWrapper":"CalendarEvent_gfeWrapper__E3F5E"};